export const getCategoryTagStyle = (category: string) => {
  switch (category) {
    case "help":
      return { bg: "bg-[#F4E7DA]", text: "text-[#E06448]", label: "Cần" };
    case "alert":
      return { bg: "bg-[#F5ECCC]", text: "text-[#C88A2A]", label: "Nhờ" };
    case "share":
      return { bg: "bg-[#DCF3FF]", text: "text-[#0071B4]", label: "Chia sẻ" };
    case "event":
      return { bg: "bg-[#FFCFFF]", text: "text-[#AD00AD]", label: "Sự kiện" };
    case "warning":
      return { bg: "bg-[#FEE4E2]", text: "text-[#F04438]", label: "Cảnh báo" };
    case "give":
      return { bg: "bg-[#D5F2EF]", text: "text-[#215E60]", label: "Cho" };
    default:
      return { bg: "bg-[#D5F2EF]", text: "text-[#215E60]", label: "Cho" };
  }
};
